import React from "react";
import { useTranslation } from "react-i18next";
import { LoadingButton, LoadingButtonProps } from "./loadingButton";
import { FormikProps } from "formik";
import Button from "@mui/material/Button";

interface IFormButtonProps {
    formik: FormikProps<any>;
    label?: string;
}

type FormButtonProps = IFormButtonProps & LoadingButtonProps;

export const SubmitButton = ({ formik, label, ...rest }: FormButtonProps) => {
    const { t } = useTranslation();

    return (
        <LoadingButton
            onClick={() => void formik.submitForm()}
            variant="contained"
            color="success"
            loading={formik.isSubmitting}
            {...rest}
        >
            {label || t("common.save")}
        </LoadingButton>
    );
};

export const ClearButton = ({ formik, label, ...rest }: FormButtonProps) => {
    const { t } = useTranslation();

    return (
        <Button
            onClick={() => void formik.resetForm()}
            variant="outlined"
            color="success"
            {...rest}
        >
            {label || t("common.clear")}
        </Button>
    );
};
